import { useEffect } from 'react'
import { goaffproService } from '../services/goaffproService'

/** Loads GoAffPro SDK and tracks referral visits (?ref= / ref cookie). */
const GoAffProTracker = () => {
  useEffect(() => {
    goaffproService.initTracking().catch(() => {
      // Non-blocking — affiliate tracking should not affect the app
    })
  }, [])

  return null
}

export default GoAffProTracker
